<template>
    <footer>
        <div class="divider"></div>

        <div class="content">
            <div class="top-footer">
                <div class="brand">
                    <router-link to="/"><UXfolioLogo /></router-link>
                </div>
                <div class="site-map">
                    <div v-for="category in siteMap"
                         :key="category.id"
                         :class="['category', {'expanded': category.expanded}]"
                         @click="category.expanded = !category.expanded"
                    >
                        <div class="title">{{ category.category }} <ArrowIcon :size="28" class="footer-category-arrow" /></div>
                        <nav>
                            <component v-for="link in category.links"
                                       :key="link.id"
                                       :is="!link.targetAttr ? 'router-link' : 'a'"
                                       :to="!link.external ? link.url : null"
                                       :href="link.url"
                                       :target="link.targetAttr"
                                       :class="{ 'has-badge': link.badge }"
                            >
                                {{ link.label }}
                                <span v-if="link.badge" class="footer-link-badge">{{ link.badge }}</span>
                            </component>
                        </nav>
                    </div>
                </div>
            </div>
        </div>

        <div class="divider"></div>

        <div class="content">
            <div class="bottom-footer">
                <div class="cc c2">© 2013 - {{ currentYear }} UXfolio LLC</div>
                <div class="controls">
                    <template v-if="showThemeToggle">
                        <CtaButton type="inline" label="Light mode" @click="setMode('light-mode')" :class="{'active' : viewData.publicPages.activeMode === 'light-mode'}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <circle cx="12.5" cy="12.5" r="7" stroke="var(--color-text)" :fill=" viewData.publicPages.activeMode === 'light-mode' ? 'var(--color-text)' : 'transparent'"/>
                            </svg>
                        </CtaButton>
                        <CtaButton type="inline" label="Dark mode" @click="setMode('dark-mode')" :class="{'active' : viewData.publicPages.activeMode === 'dark-mode'}">
                            <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                                <circle cx="12.5" cy="12.5" r="7" stroke="var(--color-text)" :fill=" viewData.publicPages.activeMode === 'dark-mode' ? 'var(--color-text)' : 'transparent'"/>
                            </svg>
                        </CtaButton>
                    </template>
                    <CtaButton type="inline" label="Back to top" @click="scrollTop()">
                        <ArrowIcon :size="16" class="footer-back-to-top-arrow" />
                    </CtaButton>

                </div>
            </div>
        </div>
    </footer>

</template>

<script>
import UXfolioLogo from "../icons/UXfolioLogo.vue";
import ArrowIcon from "../icons/ArrowIcon.vue";
import CtaButton from "./CtaButton.vue";
import {mapGetters} from "vuex";

export default {
    name: "Footer",
    components: {
        UXfolioLogo,
        ArrowIcon,
        CtaButton
    },
    data() {
        return {
            showThemeToggle: false,
            siteMap: [
                {
                    id: 1,
                    category: "Social",
                    expanded: false,
                    links: [
                        {
                            id: 1,
                            label: "Instagram",
                            url: "https://www.instagram.com/uxfolio/",
                            targetAttr: "_blank"
                        },
                        {
                            id: 2,
                            label: "LinkedIn",
                            url: "https://www.linkedin.com/company/uxfolio/",
                            targetAttr: "_blank"
                        },
                        {
                            id: 3,
                            label: "Contact us",
                            url: "mailto:support@uxfol.io",
                            targetAttr: "_blank"
                        }
                    ]
                },
                {
                    id: 2,
                    category: "Explore",
                    expanded: false,
                    links: [
                        {
                            id: 1,
                            label: "Examples",
                            url: "/examples"
                        },
                        {
                            id: 2,
                            label: "Pricing",
                            url: "/pricing"
                        },
                        {
                            id: 3,
                            label: "FAQs",
                            url: "https://support.uxfol.io/",
                            targetAttr: "_blank"
                        },
                        {
                            id: 4,
                            label: "Educational partnerships",
                            url: "/partnership-program"
                        }
                    ]
                },
                {
                    id: 3,
                    category: "Resources",
                    expanded: false,
                    links: [
                        {
                            id: 1,
                            label: "State of UX Portfolios",
                            url: "/state-of-ux-portfolios-2026",
                            badge: "New",
                            targetAttr: "_self"
                        },
                        {
                            id: 2,
                            label: "UX portfolio template",
                            url: "https://blog.uxfol.io/ux-portfolio-template/",
                            targetAttr: "_blank"
                        },
                        {
                            id: 3,
                            label: "UX designer portfolio",
                            url: "https://blog.uxfol.io/ux-designer-portfolio/",
                            targetAttr: "_blank"
                        },
                        {
                            id: 4,
                            label: "UI designer portfolio",
                            url: "https://blog.uxfol.io/ui-designer-portfolio/",
                            targetAttr: "_blank"
                        },
                        {
                            id: 5,
                            label: "Product design portfolio",
                            url: "https://blog.uxfol.io/product-design-portfolio/",
                            targetAttr: "_blank"
                        },
                        {
                            id: 6,
                            label: "UX portfolio examples",
                            url: "https://blog.uxfol.io/ux-portfolio-examples/",
                            targetAttr: "_blank"
                        }
                    ]
                },
                {
                    category: "Legal",
                    expanded: false,
                    links: [
                        {
                            id: 1,
                            label: "Terms and conditions",
                            url: "/terms-and-conditions"
                        },
                        {
                            id: 2,
                            label: "Privacy policy",
                            url: "/privacy-policy"
                        },
                        {
                            id: 3,
                            label: "Imprint",
                            url: "/imprint"
                        }
                    ]
                }
            ]
        }
    },
    mounted() {
        if (this.showThemeToggle) {
            const initUserMode = this.getTheme() || this.getMediaPreference();
            this.setMode(initUserMode);
        } else {
            this.setMode("light-mode");
        }
    },
    methods: {
        setMode(mode) {
            localStorage.setItem("uxfolio-user-theme", mode);
            document.documentElement.className = mode;
            this.viewData.publicPages.activeMode = mode;
        },
        getMediaPreference() {
            const hasDarkPreference = window.matchMedia(
                "(prefers-color-scheme: dark)"
            ).matches;

            if (hasDarkPreference) {
                return "dark-mode";
            } else {
                return "light-mode";
            }
        },
        getTheme() {
            return localStorage.getItem("uxfolio-user-theme");
        },
        scrollTop() {
            window.scroll({
                top: 0,
                left: 0,
                behavior: 'smooth'
            });
        }
    },
    computed: {
        ...mapGetters("view", ["viewData"]),
        currentYear() {
            return new Date().getFullYear()
        }
    }
}
</script>

<style lang="scss" scoped>
    @import "../../../../styles/public-pages/components/footer";
</style>